import logoWhite from "../assets/images/logo-white.png";

export const Affiliate = () => {
  return (
    <div id="affiliate" className="teams container" style={{ color: "#fff" }}>
      <div className="row" style={{ justifyContent: "center" }}>
        <span
          className="heading"
          style={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <span className="heading" style={{ color: "#4cafc8" }}>
            Refer
          </span>{" "}
          <img
            src={logoWhite}
            style={{ marginBottom: "8px", maxWidth: "215px" }}
            className="logo-header"
            alt="Devster Labs"
          />
        </span>
      </div>
      <div className="refer-card-container">
        <div className="card">
          <div className="large">3</div>
          <div className="small">partners</div>
        </div>
        <div className="card">
          <div className="large">30,000$</div>
          <div className="small">paid to partners</div>
        </div>
        <div className="card">
          <div className="large">300$<sub>/month</sub></div>
          <div className="small">Minimum income</div>
        </div>
      </div>

      <span
        className="heading"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          gap: "16px",
          width: "100%",
          maxWidth: "1024px",
          padding: "8px",
          fontSize: "clamp(14px, 5.8vw, 24px)",
          marginBottom: "16px",
          marginTop: "32px",
        }}
      >
        How does this affiliate program work?
      </span>
      <p
        style={{
          display: "block",
          width: "100%",
          maxWidth: "1024px",
          padding: "8px",
        }}
      >
        To establish a mutually beneficial partnership where you refer clients
        to Devster Labs, a leading provider of skilled developers, and earn a
        recurring passive income based on the number of developers hired by your
        referred clients.
        <br />
        <br />
        <ol className="ol-reffer" style={{ marginLeft: "20px" }}>
          <li>
            <b className="nl">Client Referral:</b>
            <br />
            You refer a client to Devster Labs, and the client hires developers
            through Devster Labs.
            <br />
            <u>
              <i>
                Example: A client hires <b>5 developers</b> at{" "}
                <b>$25,000 per month</b>.
              </i>
            </u>
          </li>
          <li>
            <b className="nl">Referral Commission:</b>
            <br />
            Devster Labs will pay you a <b>10% referral fee</b> on the total
            monthly invoice for each developer hired by your referred client.
            <br />
            <u>
              <i>
                For 5 developers: <b>$25,000 x 10% = $2,500 per month</b>{" "}
                (recurring).
              </i>
            </u>
          </li>
          <li>
            <b className="nl">Scalable Passive Income:</b>
            <br />
            <ul>
              <li>
                The more clients you refer, the higher your passive income.
              </li>
              <li>
                The more developers each client hires, the greater your monthly
                earnings.
              </li>
            </ul>
          </li>
        </ol>
      </p>
      <span
        className="heading"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          gap: "16px",
          width: "100%",
          maxWidth: "1024px",
          padding: "8px",
          fontSize: "clamp(14px, 5.8vw, 24px)",
          marginBottom: "32px",
          marginTop: "32px",
        }}
      >
        Who can make use of our affiliate program?
      </span>

      <div className="refer-card-container">
        <div className="card" style={{ maxWidth: "500px" }}>
          <div className="medium">Recruiters</div>
          <div className="small" style={{ textTransform: "none" }}>
            Connect your clients to Devster Labs, and it will be easier for you
            to assemble teams of remote specialists for them - with no
            restrictions on countries or tax status.
          </div>
        </div>
        <div className="card" style={{ maxWidth: "500px" }}>
          <div className="medium">Legal entities</div>
          <div className="small" style={{ textTransform: "none" }}>
            Reach out to clients who pay freelance individuals or remote
            specialists from other countries. Offer to optimize taxes without
            breaking the law.
          </div>
        </div>
        <div className="card" style={{ maxWidth: "1024px" }}>
          <div className="medium">Remote workers</div>
          <div className="small" style={{ textTransform: "none" }}>
            Expand your service portfolio by partnering with Devster Labs. Offer
            your clients access to top-tier remote developers, enhancing your
            value proposition and growing your business seamlessly.
          </div>
        </div>
      </div>
    </div>
  );
};
